
export default{

    app:{
        home_title:"澳门特区政府出版物销售",
        home_address:"详细地址",
        home_lr:"最新推荐",
        home_publisher:"出版机构",
        home_publishlang:"语言",
        home_publishdate:"出版日期",
        home_search:"名称/作者/出版机构",
        home_cancel:"取消",
        home_detail_title:"出版物详情",
        home_ml:"目录",
        home_category:"所属分类",
        home_author:"編著",
        home_soldmaiche:"售卖机",
        home_search_item:"搜索",
        home_sure:"确认",
        // home_selectSoldMachie:"请选择售卖机",
        home_soldOut:"已售罄",
        home_free:"免费",
        home_selectSoldMachie:"全部售卖机",
    }
    
}